import * as React from 'react';

import { Box, Button, HStack, Link, Text, VStack } from '@chakra-ui/react';
import { footerLinks, footerLinksEN } from '../../constants/links';
import { useEffect, useState } from 'react';

import ContactLinks from '../forms/contact/contact-links';
import LogOut from '../auth/logout/log-out';
import MainContentContainer from '../containers/main-content-container';
import Newsletter from './Newsletter';
import useAuth from '../../hooks/useAuth';
import useLanguage from '../../hooks/useLanguage';

const FooterContainer = () => {
  const { loggedIn } = useAuth();
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const today = new Date();
    setYear(today.getFullYear());
  }, []);
  const isEnglish = useLanguage();

  const navLinks = isEnglish ? footerLinksEN : footerLinks;

  return (
    <>
      <Box backgroundColor="gray.50" color="#1A212D" py="40px">
        <MainContentContainer>
          <Box pb="32px">
            <Newsletter />
          </Box>

          <Box w="100%" pb="32px">
            <HStack
              w="100%"
              justifyContent="space-between"
              alignItems="flex-start"
              flexFlow={{ base: "wrap", md: "nowrap" }}
              gap="24px"
            >
              <HStack
                alignItems="flex-start"
                gap="24px"
                flexFlow={{ base: 'column', sm: 'row' }}
              >
                <ContactLinks padding='0px' hasRadnoVreme />

                <VStack
                  alignItems="flex-start"
                  gap="1.5rem"
                  marginInlineStart="0px!important"
                >
                  <Text
                    fontSize="16px"
                    color="rawSienna.500"
                    fontWeight="600"
                    mt="0px!important"
                  >
                    {isEnglish ? "Website map" : "Мапа сајта"}

                  </Text>
                  {navLinks.map((item) => {
                    return (<Link
                      className="grid-numbers"
                      fontSize="14px"
                      mt="0px!important"
                      href={item.href}
                    >
                      {item.text}
                    </Link>)
                  })}
                </VStack>
              </HStack>
              <VStack
                alignItems="flex-start"
                gap="1.5rem"
                marginInlineStart="0px!important"
                w={{ base: '100%', sm: '360px' }}
              >
                <Text color="rawSienna.500" fontWeight="600" fontSize="16px">
                  {isEnglish
                    ? 'Log in to get full access to the resources'
                    : 'Улогујте се да бисте добили приступ свим ресурсима'}
                </Text>

                {loggedIn ? (
                  <LogOut />
                ) : (
                  <>
                    <Link href={isEnglish ? '/en/login' : '/prijavite-se'} w="100%">
                      <Button
                        variant="solid"
                        w={{ base: '100%', md: 'auto' }}
                      >
                        {isEnglish ? 'Log in' : 'Улогујте се'}
                      </Button>
                    </Link>
                  </>
                )}
              </VStack>
            </HStack>
          </Box>

          <HStack
            borderTop="1px solid #E1E7EF"
            alignItems="center"
            justifyContent="center"
          >
            <Box
              fontSize="14px"
              textAlign="center"
              pt="32px"
              className="grid-numbers"
            >
              © {year} | ASK | {isEnglish ? 'Copyright' : 'Сва права задржана'}
            </Box>
          </HStack>
        </MainContentContainer>
      </Box>
    </>
  );
};

export default FooterContainer;
